module.exports = __webpack_public_path__ + "media/images/icon_plus-3af5d30f42700f91fcd9e9ee55ba75a9.svg";